import React, { useState } from 'react';
import axios from 'axios';
import ButtonItem from '../components/ButtonItem';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux'; // 리덕스 저장을 위해
import { artistAction } from '../features/artist/slice'; // 리덕스 아티스트 사용

function ArtistWritePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch(); // 리덕스 저장을 위해
  const [imageUrlInput, setImageUrlInput] = useState(''); // 사용자가 입력한 URL
  const [image, setImage] = useState('/download/none_image.jpg'); // 실제 저장된 이미지 경로
  const [nameKr, setNameKr] = useState('');


  // 각 인풋 값 저장
  const imageValueChange = async (event) => {
    const url = event.target.value;
    setImageUrlInput(url);

    if (!url) {
      setImage('/download/none_image.jpg');
      return;
    }
    // 서버에 이미지 다운로드 요청
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/artist/imageDownload`,
        { url }
      );
      setImage(response.data.imagePath);
    } catch {
      setImage('/download/none_image.jpg');
    }
  };
  const nameKrValueChange = (event) => setNameKr(event.target.value);

  // 등록 버튼
  const add = async () => {
    // 입력값 검사
    if (!nameKr) {
      alert('모든 항목을 빠짐없이 입력해 주세요.');
      return;
    }
    // image가 비어있으면 기본 이미지로 설정
    const imageToSend =
      image && image.trim() !== '' ? image : '/download/none_image.jpg';

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/artist/`,
        {
          image: imageToSend,
          nameKr,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      alert('신규 아티스트 등록을 완료하였습니다.');

      // 리덕스에 아티스트 정보 저장
      dispatch(
        artistAction.changeMe({
          image: imageToSend,
          nameKr,
        })
      );

      navigate('/Artists');
    } catch (error) {
      alert('등록 중 오류가 발생했습니다.');
      dispatch(
        artistAction.changeMe({
          image: imageToSend,
          nameKr,
        })
      );
      navigate('/Artists');
    }
  };

  return (
    <>
        <div className="flex mb-8 justify-center items-center">
          <div className="text-xl sm:text-2xl font-bold text-white tracking-tight">
            <span>아티스트 등록</span>
          </div>
        </div>

        <div className="flex justify-center">
          <div className="w-[90%] max-w-[650px] space-y-6">
            {/* 프로필 이미지 Url */}
            <div>
              <label className="block font-semibold mb-1">
                프로필 이미지 Url
              </label>
              <input
                type="text"
                value={imageUrlInput}
                onChange={imageValueChange}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                placeholder="이미지 URL을 입력하세요"
              />
              <img
                src={image ? image : '/download/none_image.jpg'}
                alt={nameKr}
                className="w-[200px] h-[200px] rounded-full object-cover mx-auto shadow mt-2"
                onError={(e) => {
                  e.target.onerror = null; // 무한루프 방지
                  e.target.src = '/download/none_image.jpg';
                }}
              />
            </div>

            {/* 아티스트명 */}
            <div>
              <label className="block font-semibold mb-1">아티스트명</label>
              <input
                type="text"
                value={nameKr}
                onChange={nameKrValueChange}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
              />
            </div>
          </div>
        </div>

        <div className="w-full flex justify-end items-center mt-5">
          <ButtonItem
            className="mr-2"
            text="목록"
            color="gray"
            onClick={() => navigate('/Artists')}
          />
          <ButtonItem text="등록" color="blue" onClick={add} />
        </div>
    </>
  );
}

export default ArtistWritePage;
